
import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Separator } from '@/components/ui/separator';
import { Search } from 'lucide-react';
import { VerbosityLevel } from '@/contexts/ai-assistant/types';

interface SettingsTabProps {
  verbosityLevel: VerbosityLevel;
  setVerbosityLevel: (level: VerbosityLevel) => void;
  onBackToChat: () => void;
}

const SettingsTab: React.FC<SettingsTabProps> = ({
  verbosityLevel,
  setVerbosityLevel,
  onBackToChat
}) => {
  return (
    <div className="px-6 pb-6 space-y-6">
      <div>
        <h3 className="text-sm font-medium mb-2">Response Length</h3>
        <p className="text-xs text-muted-foreground mb-4">
          Choose how detailed you want the AI's responses to be
        </p>
        <Select 
          value={verbosityLevel} 
          onValueChange={(value) => setVerbosityLevel(value as VerbosityLevel)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select response length" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="concise">Concise</SelectItem>
            <SelectItem value="balanced">Balanced</SelectItem>
            <SelectItem value="detailed">Detailed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <Separator />
      
      <div>
        <h3 className="text-sm font-medium mb-2">Search Integration</h3>
        <div className="flex items-center gap-2">
          <Search className="h-4 w-4 text-muted-foreground" />
          <p className="text-sm">Search and chat are connected for better context</p>
        </div>
      </div>
      
      <Separator />
      
      <div>
        <h3 className="text-sm font-medium mb-2">About DirectPress AI</h3>
        <p className="text-sm text-muted-foreground">
          The AI assistant helps you navigate and understand news content on DirectPress. 
          It can answer questions about articles, explain complex topics, and cite sources.
        </p>
        <p className="text-sm text-muted-foreground mt-2">
          Your feedback helps us improve the quality of responses.
        </p>
      </div>
      
      <div className="pt-4">
        <Button 
          variant="default" 
          className="w-full"
          onClick={onBackToChat}
        >
          Return to Chat
        </Button>
      </div>
    </div>
  );
};

export default SettingsTab;
